import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import './../../App.css';
import './Employees.css';
import { CreateButton, CreateSearchBarWithPlaceHolder } from './../CommonObjects';
import { SetAuditTrail, SetAuditTrailBulk } from './../Reports/AuditTrailReportEmployeeSetup';
import axios from '../../api/apiClient';
import { token, domain } from './../Security';
import loadingSpinner from './../../assets/loading.gif';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { useTable, useSortBy } from 'react-table';
import { globalTimeFormat } from './../Security';
import {
  MAINTENACE_CLIENT,

  ClientIdSelectWithAll,
} from "../../common/APICommon";
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import SaveIcon from '@mui/icons-material/Save';
import TuneIcon from '@mui/icons-material/Tune';
import FixedLogsConfigModule from '../../v2/components/modules/FIxedLogsConfig/FixedLogsConfigModule';
import { FixedLogsUploadForm } from '../../v2/components/modules/FIxedLogsConfig/FixedLogsUploadForm';
import { useFixedLogsConfig } from '../../v2/hooks/useFixedLogsConfig';
import { useVessels } from '../../v2/hooks/useVessels';
import { FEATURES } from '../../config/features';
import { DynamicFilterBar } from '../../v2/components/filters/DynamicFilterBar';
import { useFilterManager } from '../../v2/hooks/useFilterManager';

function EmployeeSchedule({ user, userAccess, isHideSideMenu }) {
  var header = [
    "Employee Id",
    "Employee Name",
    "Shift Schedule",
    "Weekly Schedule",
    "",
  ]
  var accessor = [
    "employeeId",
    "employeeFullName",
    "shiftSchedule",
    "weeklySched",
    "manage"
  ]

  const [currentPage, setCurrentPage] = useState(1);
  const [showSetting, setShowSetting] = useState(false);
  const settingRef = useRef(null);
  const buttonRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [loadingUploadRequest, setLoadingUploadRequest] = useState(false);
  const [employeeSchedule, setEmployeeSchedule] = useState([]);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [showUploadWeeklyScheduleForm, setShowUploadWeeklyScheduleForm] = useState(false);
  const [showUploadFixedScheduleForm, setShowUploadFixedScheduleForm] = useState(false);
  const [allEmployees, setAllEmployees] = useState([]); // To pass to validation logic
  const { activeVessels } = useVessels();
  const fixedLogsHook = useFixedLogsConfig(null); // Hook instance for upload

  const [weeklySchedEmployeeData, setWeeklySchedEmployeeData] = useState([]);
  const [showViewWeeklySched, setShowViewWeeklySched] = useState(false);
  const openWeeklySchedForm = (data) => {
    setWeeklySchedEmployeeData(data);
    setShowViewWeeklySched(true);
  }
  const closeWeeklySchedForm = () => {
    setShowViewWeeklySched(false);
  }

  // Retrieve
  const [filterData, setFilterData] = useState([]);

  // Update
  const [showEditForm, setShowEditForm] = useState(false);
  const [employeeId, setEmployeeId] = useState("");
  const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
  const [employeeFullName, setEmployeeFullName] = useState("");
  const [shiftScheduleId, setShiftScheduleId] = useState("");
  const [shiftSchedule, setShiftSchedule] = useState("");
  const [oldShiftSchedule, setOldShiftSchedule] = useState("");

  const [weeklySchedule, setWeeklySchedule] = useState([]);
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end


  // Employee Fixed Logs Config
  const [showFixedLogs, setShowFixedLogs] = useState(false);
  const [selectedEmployeeIdForLogs, setSelectedEmployeeIdForLogs] = useState(null);

  const handleOpenFixedLogs = (data) => {
    setSelectedEmployeeIdForLogs(data.employeePersonalInformationId);
    setShowFixedLogs(true);
  };
  // Employee Fixed Logs Config

  const {
    activeFilterState,
    onFilterChange,
    apiFilterPayload,
    applyFilters,
    resetFilters,
    // getFiltersAsDetails
  } = useFilterManager(FEATURES.EMPLOYEE_SCHEDULE_FILTER);


  const [clientFilter, setClientFilter] = useState(null)

  const filters = useMemo(() => [
    {
      name: "Client",
      type: MAINTENACE_CLIENT,
      value: clientFilter?.id ?? 0,
      component: <ClientIdSelectWithAll data={clientFilter} setData={setClientFilter} isEditable={true} />
    },
  ], [
    clientFilter,
  ]);

  const handleFilter = (value) => {
    const lowercaseValue = value.toLowerCase();
    setCurrentPage(1);

    if (!value) {
      // If input is empty, reset to original list
      setEmployeeSchedule(filterData);
      return;
    }

    const res = filterData.filter((f) => {
      const fullNameMatch = f.employeeFullName?.toLowerCase().includes(lowercaseValue);
      const employeeIdMatch = f.employeeId?.toString().toLowerCase().includes(lowercaseValue);
      return fullNameMatch || employeeIdMatch;
    });

    setEmployeeSchedule(res);
  };

  const apiUrl = domain + "/api/Employee/employee-schedules";
  const updateApiUrl = domain + "/api/Employee/employee-schedule/update";

  const fetchDataForEmployee = useCallback(async () => {
    const apiUrl = domain + "/api/Employee/single-data";

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  }, []);
  const fetchDataForShiftSchedule = useCallback(async () => {
    const apiUrl = domain + "/api/ShiftSchedule/";

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  }, []);
  const fetchDataForLocation = useCallback(async () => {
    const apiUrl = domain + "/api/Location/";

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  }, []);
  const fetchData = useCallback(async () => {
    const _filters = apiFilterPayload.map((f) => ({
      type: f.type,
      value: f.value
    }));

    try {
      setLoading(true);
      const response = await axios.post(apiUrl + `/timekeeper/${user.employeePersonalInformationId}/filters`, _filters, {
        // const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })

      setEmployeeSchedule(response.data); // Set the response data to the state
      setFilterData(response.data); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [apiUrl, user, apiFilterPayload]);
  const fetchDataByHRAdmin = useCallback(async () => {
    const _filters = apiFilterPayload.map((f) => ({
      type: f.type,
      value: f.value
    }));

    try {
      setLoading(true);
      const response = await axios.post(apiUrl + `/filters`, _filters, {
        // const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })

      setEmployeeSchedule(response.data); // Set the response data to the state
      setFilterData(response.data); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [apiUrl, apiFilterPayload]);

  useEffect(() => {
    if (userAccess.description === "HR Head"
      || userAccess.description === "HR Assistant"
      || userAccess.description === "Admin"
    ) {
      fetchDataByHRAdmin();
    } else {
      fetchData();
    }
  }, [fetchData, fetchDataByHRAdmin, userAccess]);
  useEffect(() => {
    fetchDataForEmployee().then(data => setAllEmployees(data));
  }, [fetchDataForEmployee]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!shiftScheduleId) {
      alert("Required to fill up all data");
      return; // Exit early if fields are empty
    }

    const data = {
      employeePersonalInformationId: employeePersonalInformationId,
      employeeId: employeeId,
      employeeFullName: employeeFullName,
      shiftScheduleId: shiftScheduleId,
      shiftSchedule: shiftSchedule
    };

    try {
      await axios.put(updateApiUrl, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      setShowEditForm(false); // Hide the add form

      await SetAuditTrail({
        setupArea: "Employee Schedule",
        actionTaken: "update",
        field: "Shift Schedule",
        newValue: shiftSchedule,
        oldValue: oldShiftSchedule,
        dateSaved: new Date(),
        savedById: user.id
      });
      if (userAccess.description === "HR Head"
        || userAccess.description === "HR Assistant"
        || userAccess.description === "Admin"
      ) {
        await fetchDataByHRAdmin();
      } else {
        await fetchData();
      }

      console.log('Data added successfully');
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset form fields
      setEmployeePersonalInformationId("");
      setEmployeeId("");
      setEmployeeFullName("");
      setShiftScheduleId("");
      setShiftSchedule("");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    }

    setShowEditForm(false);
  };

  const editHandleClick = (data) => {
    setShowEditForm(true);
    setEmployeePersonalInformationId(data.employeePersonalInformationId);
    setEmployeeId(data.employeeId);
    setEmployeeFullName(data.employeeFullName);
    setShiftScheduleId(data.shiftScheduleId);
    setShiftSchedule(data.shiftSchedule);
    setOldShiftSchedule(data.shiftSchedule);
  };
  const closeEditHandleClick = () => {
    setShowEditForm(false);
  };
  const openUploadFormHandleClick = () => {
    setShowUploadForm(true);
  }
  const closeUploadFormHandleClick = () => {
    setShowUploadForm(false);
  }
  const openUploadWeeklyScheduleFormHandleClick = () => {
    setShowUploadWeeklyScheduleForm(true);
  }
  const closeUploadWeeklyScheduleFormHandleClick = () => {
    setShowUploadWeeklyScheduleForm(false);
  }

  const openUploadFixedScheduleFormHandleClick = () => {
    setShowUploadFixedScheduleForm(true);
  }
  // const closeUploadFixedScheduleFormHandleClick = () => {
  //   setShowUploadFixedScheduleForm(false);
  // }

  function formatTime(timeString) {
    const date = new Date(timeString);

    // Extract hours and minutes
    let hours = date.getHours();
    const minutes = date.getMinutes();

    // Determine AM or PM suffix
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    // Format minutes to always be two digits
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;

    // Return formatted time
    return `${hours}:${formattedMinutes} ${ampm}`;
  }

  const generateDownloadTemplate = useCallback(async () => {
    if (employeeSchedule && employeeSchedule.length <= 0) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Please wait for the employees to load");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet1 = workbook.addWorksheet('EmployeeSchedule');
    const shiftScheduleData = await fetchDataForShiftSchedule();

    const header = [
      'EmployeeId',
      'EmployeeName',
      'ShiftScheduleId',
    ];
    const headerRow = worksheet1.addRow(header);
    worksheet1.columns = [
      { key: 'employeeId', width: 30 },
      { key: 'employeeName', width: 30 },
      { key: 'shiftScheduleId', width: 30 },
    ];
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '92d050' },
      };
    });

    employeeSchedule.forEach(info => {
      worksheet1.addRow([
        info.employeeId,
        info.employeeFullName,
        info.shiftScheduleId,
      ]);
    });

    // Add reference data starting from column 5 in the same worksheet
    const startColumn = 5; // Start the reference data at column 5
    const referenceHeader = [
      'ShiftScheduleId',
      'ShiftName',
      'TimeFrom',
      'TimeTo',
    ];

    // Add the reference header in the specified column
    referenceHeader.forEach((headerText, index) => {
      const cell = worksheet1.getCell(1, startColumn + index);
      cell.value = headerText;
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '92d050' },
      };
      worksheet1.getColumn(startColumn + index).width = 30;
    });

    // Add reference data rows
    shiftScheduleData.forEach((info, rowIndex) => {
      const rowNumber = rowIndex + 2; // Start from the second row
      const dataRow = [
        info.id,
        info.shiftName,
        formatTime(info.timeFrom),
        formatTime(info.timeTo),
      ];
      dataRow.forEach((data, colIndex) => {
        worksheet1.getCell(rowNumber, startColumn + colIndex).value = data;
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, 'Employee_Schedule_Template.xlsx');
  }, [employeeSchedule, fetchDataForShiftSchedule]);
  const generateDownloadWeekylScheduleTemplate = useCallback(async () => {
    if (employeeSchedule && employeeSchedule.length <= 0) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Please wait for the employees to load");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet1 = workbook.addWorksheet('WeeklySchedule');
    const shiftScheduleData = await fetchDataForShiftSchedule();
    const locationData = await fetchDataForLocation();

    const header = [
      'EmployeeId',
      'EmployeeName',
      'Day',
      'LocationId',
      'ShiftScheduleId',
    ];
    const headerRow = worksheet1.addRow(header);
    worksheet1.columns = [
      { key: 'employeeId', width: 30 },
      { key: 'employeeName', width: 30 },
      { key: 'day', width: 30 },
      { key: 'locationId', width: 30 },
      { key: 'shiftScheduleId', width: 30 },
    ];
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '92d050' },
      };
    });

    worksheet1.addRow([
      "<12345>",
      "<DELA CRUZ, JUAN>",
      "<MONDAY>",
      "<1>",
      "<1>",
    ]);

    // Add reference data starting from column 5 in the same worksheet
    const startColumn = 7; // Start the reference data at column 5
    const referenceHeader = [
      'ShiftScheduleId',
      'ShiftName',
      'TimeFrom',
      'TimeTo',
    ];

    // Add the reference header in the specified column
    referenceHeader.forEach((headerText, index) => {
      const cell = worksheet1.getCell(1, startColumn + index);
      cell.value = headerText;
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '92d050' },
      };
      worksheet1.getColumn(startColumn + index).width = 30;
    });

    // Add reference data rows
    shiftScheduleData.forEach((info, rowIndex) => {
      const rowNumber = rowIndex + 2; // Start from the second row
      const dataRow = [
        info.id,
        info.shiftName,
        formatTime(info.timeFrom),
        formatTime(info.timeTo),
      ];
      dataRow.forEach((data, colIndex) => {
        worksheet1.getCell(rowNumber, startColumn + colIndex).value = data;
      });
    });

    // Add reference data starting from column 5 in the same worksheet
    const startColumnLoc = 12; // Start the reference data at column 5
    const referenceHeaderLoc = [
      'LocationId',
      'Description',
    ];

    // Add the reference header in the specified column
    referenceHeaderLoc.forEach((headerText, index) => {
      const cell = worksheet1.getCell(1, startColumnLoc + index);
      cell.value = headerText;
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '92d050' },
      };
      worksheet1.getColumn(startColumnLoc + index).width = 30;
    });

    // Add reference data rows
    locationData.forEach((info, rowIndex) => {
      const rowNumber = rowIndex + 2; // Start from the second row
      const dataRow = [
        info.id,
        info.description,
      ];
      dataRow.forEach((data, colIndex) => {
        worksheet1.getCell(rowNumber, startColumnLoc + colIndex).value = data;
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, 'Weekly_Schedule_Template.xlsx');
  }, [employeeSchedule, fetchDataForShiftSchedule, fetchDataForLocation]);
  const generateDownloadFixedLogsConfigTemplate = useCallback(async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('FixedLogsConfig');

    worksheet.columns = [
      { header: 'EmployeeId', key: 'employeeId', width: 20 },
      { header: 'DateFrom', key: 'dateFrom', width: 20 },
      { header: 'DateTo', key: 'dateTo', width: 20 },
      { header: 'VesselCode', key: 'vesselCode', width: 30 }, // Changed from VesselName
    ];

    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '92d050' } };
    });

    worksheet.addRow({
      employeeId: '10001',
      dateFrom: '01/01/2025', // DD/MM/YYYY
      dateTo: '15/01/2025',
      vesselCode: 'V-RAY-01', // Example Code
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), 'FixedLogs_Upload_Template.xlsx');
  }, []);

  const [uploadEmployees_temp, setUploadEmployees_temp] = useState([])
  const uploadEmployeeData = async (file) => {
    setLoadingUploadRequest(true);
    const dataEmployee = await fetchDataForEmployee();
    const dataShiftSchedule = await fetchDataForShiftSchedule();

    function sanitizeValue(value) {
      if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
        return '';
      }
      return value;
    }

    function validateData(data) {
      let newData = [];

      data.forEach((item, index) => {
        const missing = [];

        if (!item.employeeId) missing.push('Employee Id');
        if (!item.shiftScheduleId) missing.push('Shift Schedule Id');

        // ✅ Construct error message properly
        let errorMessage = "";

        const existingEmployee = dataEmployee.find(employee => employee.employeeId === item.employeeId?.toString());
        if (!existingEmployee) {
          errorMessage += errorMessage.length > 0 ? ` Employee Id does not exist` : `Employee Id does not exist. `;
        }

        if (missing.length > 0) {
          errorMessage += ` Missing fields - ${missing.join(', ')}`;
        }

        newData.push({ ...item, errors: errorMessage });
      });

      newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

      return newData;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const parseWorksheet = (worksheet) => {
        return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
      };

      const informations = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

      let bulkData = [];

      informations.forEach(info => {
        let foundEmployee = null;
        let foundShiftSchedule = null;

        foundEmployee = dataEmployee.find(data => data.employeeId.toLowerCase() === sanitizeValue(info.EmployeeId).toString().toLowerCase());
        foundShiftSchedule = dataShiftSchedule.find(data => data.id.toString() === sanitizeValue(info.ShiftScheduleId).toString());

        // i will use the locations, employments etc. here below
        if (foundEmployee) {
          bulkData.push({
            employeeId: sanitizeValue(info.EmployeeId).toString(),
            fullName: sanitizeValue(info.EmployeeName),
            employeePersonalInformationId: foundEmployee ?
              sanitizeValue(foundEmployee.id)
              :
              0,
            shiftScheduleId: foundShiftSchedule ?
              sanitizeValue(foundShiftSchedule.id)
              :
              null,
          });
        } else if (sanitizeValue(info.EmployeeId).toString()) {
          bulkData.push({
            employeeId: sanitizeValue(info.EmployeeId).toString(),
            fullName: sanitizeValue(info.EmployeeName),
            shiftScheduleId: foundShiftSchedule ?
              sanitizeValue(foundShiftSchedule.id)
              :
              null,
          });
        }
      });

      const validatedData = validateData(bulkData);
      const sortedData = validatedData.sort((a, b) => {
        const hasErrorA = a.errors && a.errors.length > 0;
        const hasErrorB = b.errors && b.errors.length > 0;

        return hasErrorB - hasErrorA; // Move items with errors to the top
      });

      setUploadEmployees_temp(sortedData);

      // Validate the bulk data
      /* const validation = validateData(bulkData);
      if (!validation.isValid) {
          setLoadingRequest(false);
          setShowRequestMessage(true);
          setIsSuccess(false);
          setRequestMessage(validation.message.split('\n').map((line, index) => (
              <div key={index}>{line}</div>
          )));
          return;
      }

      const upload = async (data) => {
          const apiUrl = `${domain}/api/Employee/employee-schedule/update/bulk`;
      
          try {
              const response = await axios.put(apiUrl, data, {
                  headers: {
                      'Authorization': `Bearer ${token}`,
                      'Content-Type': 'application/json'
                  }
              });
              await SetAuditTrail({
                  setupArea: "Employee Schedule", 
                  actionTaken: "upload", 
                  field: "Upload Employee Schedule", 
                  newValue: "[bulk data]", 
                  oldValue: "-", 
                  dateSaved: new Date(), 
                  savedById: user.id
              });

              if(userAccess.description === "HR Head"
                  || userAccess.description === "HR Assistant"
                  || userAccess.description === "Admin"
              ){
                  await fetchDataByHRAdmin();
              } else {
                  await fetchData();
              }
              console.log('Upload successful:', response.data);
              setLoadingRequest(false);
              setRequestMessage('Upload successful');
              setShowRequestMessage(true);
              setIsSuccess(true);
          } catch (error) {
              setLoadingRequest(false);
              setShowRequestMessage(true);
              setIsSuccess(false);
              console.error('Error:', error);
              const errorMessage = error.response?.data?.message || 'An error occurred';
              setRequestMessage(errorMessage);
              throw error; // Rethrow the error to handle it in the Promise.all context
          }
      }

      upload(bulkData); */
    };

    setLoadingUploadRequest(false);
    reader.readAsArrayBuffer(file);
  };
  function handleFileUpload(files) {
    if (!files || files.length === 0) {
      console.error('No files selected');
      return;
    }

    const file = files[0];
    uploadEmployeeData(file);
  }
  const handleFinalFileUpload = async (bulkData) => {
    setLoadingRequest(true);

    const apiUrl = `${domain}/api/Employee/employee-schedule/update/bulk`;

    try {
      await axios.put(apiUrl, bulkData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      await SetAuditTrail({
        setupArea: "Employee Schedule",
        actionTaken: "upload",
        field: "Upload Employee Schedule",
        newValue: "[bulk data]",
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      if (userAccess.description === "HR Head"
        || userAccess.description === "HR Assistant"
        || userAccess.description === "Admin"
      ) {
        await fetchDataByHRAdmin();
      } else {
        await fetchData();
      }

      setLoadingRequest(false);
      setRequestMessage('Upload successful');
      setShowRequestMessage(true);
      setIsSuccess(true);
    } catch (error) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = error.response?.data?.message || 'An error occurred';
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  }

  const [uploadWeeklySchedule_temp, setUploadWeeklySchedule_temp] = useState([])
  const uploadEmployeeWeeklySchedData = async (file) => {
    setLoadingUploadRequest(true);
    const dataEmployee = await fetchDataForEmployee();
    const dataShiftSchedule = await fetchDataForShiftSchedule();
    const dataLocation = await fetchDataForLocation();

    function sanitizeValue(value) {
      if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
        return '';
      }
      return value;
    }

    function validateData(data) {
      let newData = [];

      data.forEach((item, index) => {
        const missing = [];

        if (!item.employeeId) missing.push('Employee Id');
        if (!item.shiftScheduleId) missing.push('Shift Schedule Id');
        if (!item.day) missing.push('Day');
        if (!item.locationId) missing.push('Location Id');

        // ✅ Construct error message properly
        let errorMessage = "";

        const existingEmployee = dataEmployee.find(employee => employee.employeeId === item.employeeId?.toString());
        if (!existingEmployee) {
          errorMessage += errorMessage.length > 0 ? ` Employee Id does not exist.` : `Employee Id does not exist. `;
        }

        if (item.day && !["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"].includes(item.day.toLowerCase())) {
          errorMessage += errorMessage.length > 0 ? ` Day input is not a valid day.` : `Day input is not a valid day. `;
        }

        if (missing.length > 0) {
          errorMessage += ` Missing fields - ${missing.join(', ')}`;
        }

        newData.push({ ...item, errors: errorMessage });
      });

      newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

      return newData;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const parseWorksheet = (worksheet) => {
        return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
      };

      const informations = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

      let bulkData = [];

      informations.forEach(info => {
        let foundEmployee = null;
        let foundShiftSchedule = null;
        let foundLocation = null;

        foundEmployee = dataEmployee.find(data => data.employeeId.toString().toLowerCase() === sanitizeValue(info.EmployeeId).toString().toLowerCase());
        foundShiftSchedule = dataShiftSchedule.find(data => data.id.toString() === sanitizeValue(info.ShiftScheduleId).toString());
        foundLocation = dataLocation.find(data => data.id.toString() === sanitizeValue(info.LocationId).toString());

        // i will use the locations, employments etc. here below
        if (foundEmployee) {
          bulkData.push({
            employeePersonalInformationId: foundEmployee ?
              sanitizeValue(foundEmployee.id)
              :
              0,
            employeeId: sanitizeValue(info.EmployeeId).toString(),
            fullName: sanitizeValue(info.EmployeeName),
            shiftScheduleId: foundShiftSchedule ?
              sanitizeValue(foundShiftSchedule.id)
              :
              null,
            locationId: foundLocation ?
              sanitizeValue(foundLocation.id)
              :
              null,
            day: sanitizeValue(info.Day)
          });
        } else if (sanitizeValue(info.EmployeeId).toString()) {
          bulkData.push({
            employeeId: sanitizeValue(info.EmployeeId).toString(),
            fullName: sanitizeValue(info.EmployeeName),
            shiftScheduleId: foundShiftSchedule ?
              sanitizeValue(foundShiftSchedule.id)
              :
              null,
            locationId: foundLocation ?
              sanitizeValue(foundLocation.id)
              :
              null,
            day: sanitizeValue(info.Day)
          });
        }
      });

      // Validate the bulk data
      const validatedData = validateData(bulkData);
      const sortedData = validatedData.sort((a, b) => {
        const hasErrorA = a.errors && a.errors.length > 0;
        const hasErrorB = b.errors && b.errors.length > 0;

        return hasErrorB - hasErrorA; // Move items with errors to the top
      });
      setUploadWeeklySchedule_temp(sortedData)
    };

    setLoadingUploadRequest(false);
    reader.readAsArrayBuffer(file);
  };
  function handleFileUploadWeeklySchedule(files) {
    if (!files || files.length === 0) {
      console.error('No files selected');
      return;
    }

    const file = files[0];
    uploadEmployeeWeeklySchedData(file);
  }
  const handleFinalFileUploadWeeklySchedule = async (bulkData) => {
    setLoadingRequest(true);

    const apiUrl = `${domain}/api/EmployeeShiftSchedule/bulk`;

    try {
      const response = await axios.post(apiUrl, bulkData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      await SetAuditTrail({
        setupArea: "Employee Schedule",
        actionTaken: "upload",
        field: "Upload Weekly Schedule",
        newValue: "[bulk data]",
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      if (userAccess.description === "HR Head"
        || userAccess.description === "HR Assistant"
        || userAccess.description === "Admin"
      ) {
        await fetchDataByHRAdmin();
      } else {
        await fetchData();
      }
      console.log('Upload successful:', response.data);
      setLoadingRequest(false);
      setRequestMessage('Upload successful');
      setShowRequestMessage(true);
      setIsSuccess(true);
    } catch (error) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);
      const errorMessage = error.response?.data?.message || 'An error occurred';
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }
  }

  const handleSetting = () => {
    setShowSetting(!showSetting);
  };

  useEffect(() => {
    var settingIcon = document.getElementById("setting-icon");

    if (showSetting) {
      //change the down icon to up
      settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
      settingIcon.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`); // Up Arrow.Path d attribute    
    } else {
      //change the up icon to down
      settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
      settingIcon.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`); // Down Arrow.Path d attribute
    }

    const handleClickOutside = (event) => {
      if (settingRef.current && !settingRef.current.contains(event.target)) {
        if (buttonRef.current && !buttonRef.current.contains(event.target)) {
          setShowSetting(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };


  }, [showSetting]);

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="EmployeesTabInfo shadow-xl">
            <div className="employeesTab-header">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Personnel >"} </span>
                <span style={{ borderBottom: "1px solid black" }}>{"Employee Schedule"}</span>
              </div>
              <div className='row' style={{ justifyContent: "space-between", alignItems: "center" }}>
                <h3>Employee Schedule</h3>
                <div style={{ width: "30%", textAlign: "right" }}>
                  <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                    <SettingsIcon />
                    <KeyboardArrowDownIcon id="setting-icon" />
                  </button>
                  <div ref={settingRef}>
                    {showSetting &&
                      <SettingInit
                        generateDownloadTemplate={generateDownloadTemplate}
                        openUploadFormHandleClick={openUploadFormHandleClick}
                        generateDownloadWeekylScheduleTemplate={generateDownloadWeekylScheduleTemplate}
                        openUploadWeeklyScheduleFormHandleClick={openUploadWeeklyScheduleFormHandleClick}
                        generateDownloadFixedLogsConfigTemplate={generateDownloadFixedLogsConfigTemplate}
                        openUploadFixedScheduleFormHandleClick={openUploadFixedScheduleFormHandleClick}
                      />}
                  </div>

                </div>
              </div>
            </div>
            <div className="employeesTab-body">
              {FEATURES.IS_DYNAMIC_FILTER ?
                <div className="">
                  <div className="bg-white rounded-lg border border-gray-200 p-5 shadow-sm" style={{ border: "1px solid #d7d7d7" }}>
                    <span className="text-sm font-bold text-gray-500 uppercase tracking-widest mb-4 block">Filter</span>
                    <DynamicFilterBar
                      requestedFilters={FEATURES.EMPLOYEE_SCHEDULE_FILTER}
                      activeFilterState={activeFilterState}
                      onFilterChange={onFilterChange}
                      onApply={applyFilters}
                      onClear={resetFilters}
                      allowAll={true}
                      showButtons={true}
                    />
                  </div>
                </div>
              :
                <div className='filters-payroll'>
                  <span>Filter</span>
                  <div
                    className="payroll-item-holder info-item-holder flex flex-wrap gap-4 px-[10px] pb-[20px]"
                    style={{ justifyContent: "flex-start" }}
                  >
                    {filters.map((filter) => {
                      return (
                        <div className="filter-item-payroll popUp-item info-item column" key={filter.id}>
                          <div className="info-item-label">{filter.name}</div>
                          <div className="info-item-input">
                            {filter.component}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              }
              <div className="body-top row">
                <div className="body-top-search">
                  {CreateSearchBarWithPlaceHolder("",
                    "mainte-search row",
                    "mainte-search-icon",
                    "mainte-search-input",
                    (e) => handleFilter(e.target.value),
                    "Search ...",
                    SearchIcon)}
                </div>
              </div>
              <div className="employeesTab-table container">
                <CreateTable
                  dataList={employeeSchedule}
                  dataHeader={header}
                  dataAccessor={accessor}
                  editHandleClick={editHandleClick}
                  openFixedLogs={handleOpenFixedLogs} // ADDED
                  viewSchedule={openWeeklySchedForm}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <EditForm isOpen={showEditForm}
        onClose={closeEditHandleClick}
        employeePersonalInformationId={employeePersonalInformationId}
        employeeFullName={employeeFullName}
        shiftSchedule={shiftSchedule}
        setEmployeePersonalInformationId={setEmployeePersonalInformationId}
        setEmployeeFullName={setEmployeeFullName}
        setShiftSchedule={setShiftSchedule}
        setShiftScheduleId={setShiftScheduleId}
        handleSubmit={handleSubmit}
      >
      </EditForm>
      <UploadForm isOpen={showUploadForm}
        onClose={closeUploadFormHandleClick}
        uploadEmployees_temp={uploadEmployees_temp}
        setUploadEmployees_temp={setUploadEmployees_temp}
        handleFileUpload={handleFileUpload}
        handleFinalFileUpload={handleFinalFileUpload}
      >
      </UploadForm>
      <div className={`modal-overlay ${showFixedLogs ? 'open' : ''}`}>
        {showFixedLogs && (
          <div className="modal" style={{ width: '80%', maxWidth: '1000px' }}>
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Fixed Logs Configuration</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => setShowFixedLogs(false)} className="cursor-pointer" />
              </div>
            </div>
            <div className="popUp-body">
              <FixedLogsConfigModule
                user={user}
                employeePersonalInformationId={selectedEmployeeIdForLogs}
              />
            </div>
          </div>
        )}
      </div>
      <UploadWeeklyScheduleForm isOpen={showUploadWeeklyScheduleForm}
        onClose={closeUploadWeeklyScheduleFormHandleClick}
        data_temp={uploadWeeklySchedule_temp}
        setData_temp={setUploadWeeklySchedule_temp}
        handleFileUpload={handleFileUploadWeeklySchedule}
        handleFinalFileUpload={handleFinalFileUploadWeeklySchedule}
      >
      </UploadWeeklyScheduleForm>
      <ViewWeeklyScheduleForm isOpen={showViewWeeklySched}
        onClose={closeWeeklySchedForm}
        weeklySchedule={weeklySchedule}
        setWeeklySchedule={setWeeklySchedule}
        weeklySchedEmployeeData={weeklySchedEmployeeData}
        user={user}
      >
      </ViewWeeklyScheduleForm>
      <FixedLogsUploadForm
        isOpen={showUploadFixedScheduleForm}
        onClose={() => setShowUploadFixedScheduleForm(false)}
        hookProps={fixedLogsHook}
        allEmployees={allEmployees}
        activeVessels={activeVessels}
      />
      <GenerateMessage
        form={fixedLogsHook.showMessage || showRequestMessage}
        message={fixedLogsHook.showMessage ? fixedLogsHook.message : (isSuccess ? "Request Success!" : requestMessage)}
        isSuccess={fixedLogsHook.showMessage ? fixedLogsHook.isSuccess : isSuccess}
      />

      {loadingRequest || loading ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      }
      {loadingUploadRequest ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "10000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      }
    </div>
  )
}

function EditForm({ isOpen,
  onClose,
  employeePersonalInformationId,
  employeeFullName,
  shiftSchedule,
  setEmployeePersonalInformationId,
  setEmployeeFullName,
  setShiftSchedule,
  setShiftScheduleId,
  handleSubmit }) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Update Employee Schedule</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Employee</div>
                <div className="info-item-input">
                  <input
                    readOnly
                    id="employeePersonalInformationId"
                    placeholder="Employee Id"
                    value={employeeFullName}
                    style={{ cursor: "not-allowed" }}
                  />
                </div>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Shift Schedule</div>
                <div className="info-item-input">
                  {ShiftScheduleSelect(shiftSchedule, setShiftSchedule, setShiftScheduleId)}
                </div>
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={handleSubmit}>
                SAVE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function ShiftScheduleSelect(shiftSchedule, setShiftSchedule, setShiftScheduleId) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setShiftSchedule(event.target.value);
  };

  const [shiftSchedules, setShiftSchedules] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/ShiftSchedule";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        setShiftSchedules(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (shiftSchedule !== "" && shiftSchedule !== null) {
      setIsSelected(true);
    } else {
      setShiftSchedule("");
      setIsSelected(false);
    }

    const targetShiftSchedule = shiftSchedules.find(_shiftSchedule => _shiftSchedule.shiftName === shiftSchedule);
    if (targetShiftSchedule !== undefined && targetShiftSchedule !== null && targetShiftSchedule !== "") {
      setShiftScheduleId(targetShiftSchedule.id);
    }

  }, [shiftSchedule, setShiftSchedule, setShiftScheduleId, shiftSchedules]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={shiftSchedule} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose shift schedule</option>
        {shiftSchedules.map((shiftSchedule) => (
          SetShiftSchedule(shiftSchedule)
        ))}
      </select>
    </div>
  );
};
function SetShiftSchedule(shiftSchedule) {
  const formatTime = (time) => {
    let timeParts;
    let formattedTime;

    if (globalTimeFormat === "Standard Time") {
      const timeSplit = time.split('T');
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(':');
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      formattedTime = `${hours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time") {
      const timeSplit = time.split('T');
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(':');
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      formattedTime = `${hours}:${minutes}`;
    }

    return formattedTime;
  }

  return (
    <option id={"leaveType" + shiftSchedule.id} value={shiftSchedule.shiftName}>{`${shiftSchedule.id} -  ${shiftSchedule.shiftName} (${formatTime(shiftSchedule.timeFrom)} - ${formatTime(shiftSchedule.timeTo)}) `}
    </option>
  )

}
function SettingInit({
  generateDownloadTemplate,
  generateDownloadWeekylScheduleTemplate,
  generateDownloadFixedLogsConfigTemplate,
  openUploadFormHandleClick,
  openUploadWeeklyScheduleFormHandleClick,
  openUploadFixedScheduleFormHandleClick
}) {
  return (
    <div id='payroll-setting' className="payroll-setting column">
      <div className="payroll-setting-item row" onClick={() => generateDownloadTemplate(false)}>
        <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}><DownloadIcon /></div>
        Download Template
      </div>
      <div className="payroll-setting-item row" onClick={() => generateDownloadWeekylScheduleTemplate(false)}>
        <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}><DownloadIcon /></div>
        Download Weekly Schedule Template
      </div>
      {FEATURES.TIMEENTRIES_FIXEDLOGS_CONFIG && (
        <div className="payroll-setting-item row" onClick={() => generateDownloadFixedLogsConfigTemplate(false)}>
          <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}><DownloadIcon /></div>
          Download Fixed Logs Config Template
        </div>
      )}

      <div className="payroll-setting-item row" onClick={() => openUploadFormHandleClick()}>
        <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}><FileUploadIcon /></div>
        Upload Employee Schedule
      </div>
      <div className="payroll-setting-item row" onClick={() => openUploadWeeklyScheduleFormHandleClick()}>
        <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}><FileUploadIcon /></div>
        Upload Weekly Schedule
      </div>
      {FEATURES.TIMEENTRIES_FIXEDLOGS_CONFIG && (
        <div className="payroll-setting-item row" onClick={() => openUploadFixedScheduleFormHandleClick()}>
          <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}><FileUploadIcon /></div>
          Upload Fixed Logs Config
        </div>
      )}
    </div>
  )
}
function UploadForm({ isOpen,
  onClose,
  uploadEmployees_temp,
  setUploadEmployees_temp,
  handleFileUpload,
  handleFinalFileUpload }
) {
  const handleClose = () => {
    onClose();
    setFiles("");
    setUploadEmployees_temp([]);
  };

  const [files, setFiles] = useState([]);
  const [currentFiles, setCurrentFiles] = useState([]);
  const [hasNoError, setHasNoError] = useState(false);

  useEffect(() => {
    if (uploadEmployees_temp.length > 0) {
      const _errorData = uploadEmployees_temp.filter(i => i.errors.length > 0)

      if (_errorData.length <= 0) {
        setHasNoError(true)
      } else {
        setHasNoError(false)
      }
    }
  }, [uploadEmployees_temp])

  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    setFiles(fileList);
    e.currentTarget.style.backgroundColor = "white";
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById('fileInput').value = '';
    setUploadEmployees_temp([]);
  };

  useEffect(() => {
    if (currentFiles !== files) {
      setCurrentFiles(files)
      handleFileUpload(files);
    }
  }, [files, handleFileUpload, currentFiles])

  const submit = (e) => {
    handleFinalFileUpload(uploadEmployees_temp);
    handleClose();
  };

  const [currentPage, setCurrentPage] = useState(1);
  var header = [
    "Employee Id",
    "Employee Name",
    "Shift Schedule Id",
    "Error",
  ]
  var accessor = [
    "employeeId",
    "fullName",
    "shiftScheduleId",
    "errors",
  ]

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{"Upload Employee's Schedule"}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>

            <div className="popUp-body user-template-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>

            </div>

            <div>
              <label htmlFor="fileInput" className='browse'>Browse...</label>
              <input
                type="file"
                id="fileInput"
                onChange={(e) => handleBrowse(e)}
                style={{ display: 'none' }}
              />
              <div
                id='drop-files-here'
                onDrop={(e) => handleDrop(e)}
                onDragOver={(e) => handleDragOver(e)}
                onDragLeave={(e) => handleDragOut(e)}
                style={{
                  border: '2px dashed #ccc',
                  borderRadius: '5px',
                  padding: '20px',
                  marginTop: '10px',
                  textAlign: 'center',
                }}
              >
                Drop files here
              </div>
              {files.length > 0 && (
                <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                  <span>Uploaded File:</span>
                  <ul>
                    {files.map((file, index) => (
                      <span key={index}>{file.name}</span>
                    ))}
                  </ul>
                  <div className="buttons row" style={{ display: "flex", justifyContent: "end" }}>
                    <button id="add-family"
                      className="cancel row"
                      onClick={() => clearFiles()}
                      style={{ marginRight: "5px", height: "34px", borderRadius: "3px" }}>
                      CLEAR
                    </button>
                  </div>
                </div>
              )}
            </div>
            {files.length > 0 && (
              <>
                {hasNoError ?
                  <>
                    <div style={{ marginTop: "10px", padding: "10px", backgroundColor: "#4cc92a", color: "white" }}>
                      Data is valid.
                    </div>
                  </>
                  :
                  <>
                    <div style={{ marginTop: "10px", padding: "10px", backgroundColor: "#ce3434", color: "white" }}>
                      Cannot upload with error.
                    </div>
                  </>
                }
                <div className='employeesTab-tab upload-preview-tab' style={{ marginTop: "10px" }}>
                  <div id="container1 table-uploads" className="employeesTab-table container">
                    <CreateTableForUpload
                      dataList={uploadEmployees_temp}
                      dataHeader={header}
                      dataAccessor={accessor}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
                <div className="buttons row" style={{ justifyContent: "end", padding: "40px 40px 20px 40px" }}>
                  {hasNoError && <button id="add-family"
                    className="save row"
                    onClick={(e) => submit(e)}
                    style={{ marginRight: "5px" }}>
                    UPLOAD
                  </button>}
                  <button id="add-family"
                    className="cancel row"
                    style={{ marginRight: "5px", height: "34px", borderRadius: "3px" }}
                    onClick={() => handleClose()}>
                    CANCEL
                  </button>
                </div>
              </>
            )
            }


          </div>
        )}
      </div>
    </>
  );
}
function UploadWeeklyScheduleForm({ isOpen,
  onClose,
  data_temp,
  setData_temp,
  handleFileUpload,
  handleFinalFileUpload }
) {
  const handleClose = () => {
    onClose();
    setFiles("");
    setData_temp([]);
  };

  const [files, setFiles] = useState([]);
  const [currentFiles, setCurrentFiles] = useState([]);
  const [hasNoError, setHasNoError] = useState(false);

  useEffect(() => {
    if (data_temp.length > 0) {
      const _errorData = data_temp.filter(i => i.errors.length > 0)

      if (_errorData.length <= 0) {
        setHasNoError(true)
      } else {
        setHasNoError(false)
      }
    }
  }, [data_temp])

  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    setFiles(fileList);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    setFiles(fileList);
    e.currentTarget.style.backgroundColor = "white";
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };
  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };
  const clearFiles = () => {
    // Clear the files state
    setFiles([]);
    // Reset the value of the file input
    document.getElementById('fileInput').value = '';
    setData_temp([]);
  };

  useEffect(() => {
    if (currentFiles !== files) {
      setCurrentFiles(files)
      handleFileUpload(files);
    }
  }, [files, handleFileUpload, currentFiles])

  const submit = (e) => {
    handleFinalFileUpload(data_temp);
    handleClose();
  };

  const [currentPage, setCurrentPage] = useState(1);
  var header = [
    "Employee Id",
    "Employee Name",
    "Day",
    "Location Id",
    "Shift Schedule Id",
    "Error",
  ]
  var accessor = [
    "employeeId",
    "fullName",
    "day",
    "locationId",
    "shiftScheduleId",
    "errors",
  ]

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{"Upload Weekly Schedule"}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>

            <div className="popUp-body user-template-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>

            </div>

            <div>
              <label htmlFor="fileInput" className='browse'>Browse...</label>
              <input
                type="file"
                id="fileInput"
                onChange={(e) => handleBrowse(e)}
                style={{ display: 'none' }}
              />
              <div
                id='drop-files-here'
                onDrop={(e) => handleDrop(e)}
                onDragOver={(e) => handleDragOver(e)}
                onDragLeave={(e) => handleDragOut(e)}
                style={{
                  border: '2px dashed #ccc',
                  borderRadius: '5px',
                  padding: '20px',
                  marginTop: '10px',
                  textAlign: 'center',
                }}
              >
                Drop files here
              </div>
              {files.length > 0 && (
                <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                  <span>Uploaded File:</span>
                  <ul>
                    {files.map((file, index) => (
                      <span key={index}>{file.name}</span>
                    ))}
                  </ul>
                  <div className="buttons row" style={{ display: "flex", justifyContent: "end" }}>
                    <button id="add-family"
                      className="cancel row"
                      onClick={() => clearFiles()}
                      style={{ marginRight: "5px", height: "34px", borderRadius: "3px" }}>
                      CLEAR
                    </button>
                  </div>
                </div>
              )}
            </div>
            {files.length > 0 && (
              <>
                {hasNoError ?
                  <>
                    <div style={{ marginTop: "10px", padding: "10px", backgroundColor: "#4cc92a", color: "white" }}>
                      Data is valid.
                    </div>
                  </>
                  :
                  <>
                    <div style={{ marginTop: "10px", padding: "10px", backgroundColor: "#ce3434", color: "white" }}>
                      Cannot upload with error.
                    </div>
                  </>
                }
                <div className='employeesTab-tab upload-preview-tab' style={{ marginTop: "10px" }}>
                  <div id="container1 table-uploads" className="employeesTab-table container">
                    <CreateTableForUpload
                      dataList={data_temp}
                      dataHeader={header}
                      dataAccessor={accessor}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
                <div className="buttons row" style={{ justifyContent: "end", padding: "40px 40px 20px 40px" }}>
                  {hasNoError && <button id="add-family"
                    className="save row"
                    onClick={(e) => submit(e)}
                    style={{ marginRight: "5px" }}>
                    UPLOAD
                  </button>}
                  <button id="add-family"
                    className="cancel row"
                    style={{ marginRight: "5px", height: "34px", borderRadius: "3px" }}
                    onClick={() => handleClose()}>
                    CANCEL
                  </button>
                </div>
              </>
            )
            }


          </div>
        )}
      </div>
    </>
  );
}
function ViewWeeklyScheduleForm({ isOpen,
  onClose,
  weeklySchedule,
  setWeeklySchedule,
  weeklySchedEmployeeData,
  user
}) {
  var header = [
    "Day",
    "Location",
    "Shift Schedule",
    "",
  ]
  var accessor = [
    "day",
    "locationDescription",
    "shiftScheduleShiftName",
    "manage"
  ]

  const [dayType, setDayType] = useState("");
  const [locationId, setLocationId] = useState("");
  const [shiftScheduleId, setShiftScheduleId] = useState("");

  const [oldDayType, setOldDayType] = useState("");
  const [oldLocationId, setOldLocationId] = useState("");
  const [oldShiftScheduleId, setOldShiftScheduleId] = useState("");

  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [schedulesAddState, setSchedulesAddState] = useState(false);
  const [schedulesUpdateState, setSchedulesUpdateState] = useState(false);

  //Update
  const [editData, setEditData] = useState([]);

  //Delete
  const [showDeleteForm, setShowDeleteForm] = useState("");
  const [deleteData, setDeleteData] = useState([]);

  const openDeleteForm = (data) => {
    setDeleteData(data);
    setShowDeleteForm(true);
  }
  const closeDeleteForm = () => {
    setShowDeleteForm(false);
  }

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const fetchData = useCallback(async () => {
    const apiUrl = domain + "/api/EmployeeShiftSchedule";

    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      const finalData = response.data.filter(data => data.employeePersonalInformationId === weeklySchedEmployeeData.employeePersonalInformationId);
      setWeeklySchedule(finalData); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  }, [setWeeklySchedule, weeklySchedEmployeeData]);

  useEffect(() => {
    if (isOpen) {
      fetchData();
    }
  }, [isOpen, fetchData])

  const handleSubmit = async (event) => {
    event.preventDefault();

    const apiUrl = domain + "/api/EmployeeShiftSchedule";

    const data = {
      employeePersonalInformationId: weeklySchedEmployeeData.employeePersonalInformationId,
      shiftScheduleId: shiftScheduleId,
      locationId: locationId,
      day: dayType
    };

    try {
      setLoadingRequest(true);
      const response = await axios.post(apiUrl, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      addHandleClick_cancel(); // Hide the add form
      await SetAuditTrail({
        setupArea: "Employee Schedule",
        actionTaken: "insert",
        field: "Add Weekly Schedule",
        newValue: `${response.data.locationDescription}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });
      await fetchData(); // Assuming fetchData() fetches the updated data for the table

      console.log('Data added successfully');
      setShowRequestMessage(true);
      setIsSuccess(true);

      setLocationId("");
      setShiftScheduleId("");
      setDayType("");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    addHandleClick_cancel();
  };
  const handleUpdate = async (event) => {
    event.preventDefault();

    const apiUrl = domain + "/api/EmployeeShiftSchedule";

    const data = {
      employeePersonalInformationId: weeklySchedEmployeeData.employeePersonalInformationId,
      shiftScheduleId: shiftScheduleId,
      locationId: locationId,
      day: dayType
    };

    try {
      setLoadingRequest(true);
      await axios.put(apiUrl + `/${editData.id}`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      let auditInfo = [];

      if (data.shiftScheduleId !== oldShiftScheduleId) {
        auditInfo.push({
          setupArea: "Employee Schedule",
          actionTaken: "update",
          field: "Weekly Schedule",
          newValue: `${data.shiftScheduleId}`,
          oldValue: `${oldShiftScheduleId}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.locationId !== oldLocationId) {
        auditInfo.push({
          setupArea: "Employee Schedule",
          actionTaken: "update",
          field: "Weekly Schedule",
          newValue: `${data.locationId}`,
          oldValue: `${oldLocationId}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }
      if (data.day !== oldDayType) {
        auditInfo.push({
          setupArea: "Employee Schedule",
          actionTaken: "update",
          field: "Weekly Schedule",
          newValue: `${data.day}`,
          oldValue: `${oldDayType}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      updateHandleClick_cancel();
      await SetAuditTrailBulk({ data: auditInfo });
      await fetchData(); // Assuming fetchData() fetches the updated data for the table

      console.log('Data updated successfully');
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset form fields
      setLocationId("");
      setShiftScheduleId("");
      setDayType("");
      setEditData([]);
    } catch (error) {
      console.error('There was a problem updating data:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    updateHandleClick_cancel();
  };
  const handleDelete = async () => {
    const apiUrl = domain + "/api/EmployeeShiftSchedule";

    try {
      setLoadingRequest(true);
      await axios.delete(apiUrl + `/${deleteData.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      await fetchData(); // Assuming fetchData() fetches the updated data for the table
      console.log('Deleted successfully');
      setShowRequestMessage(true);
      setIsSuccess(true);

      // Reload table data and reset state
      setShowDeleteForm(false);
      setDeleteData([]);
    } catch (error) {
      setLoadingRequest(false);
      console.error('There was a problem deleting employee:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowDeleteForm(false);
  };

  const handleClose = () => {
    onClose();
    addHandleClick_cancel();
    updateHandleClick_cancel();
  };

  const addHandleClick = () => {
    setSchedulesAddState(true);
  }
  const addHandleClick_cancel = () => {
    setLocationId("");
    setShiftScheduleId("");
    setDayType("");
    setSchedulesAddState(false);
  }
  const updateHandleClick = (data) => {
    setEditData(data);
    setDayType(data.day);
    setLocationId(data.locationId);
    setShiftScheduleId(data.shiftScheduleId);
    setOldDayType(data.day);
    setOldLocationId(data.locationId);
    setOldShiftScheduleId(data.shiftScheduleId);
    setSchedulesUpdateState(true);
  }
  const updateHandleClick_cancel = () => {
    setLocationId("");
    setShiftScheduleId("");
    setDayType("");
    setSchedulesUpdateState(false);
  }

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Weekly Schedule</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body loan-history-table user-template-body">
              <div className="transaction-addBtn row" style={{ margin: "10px 0" }}>
                {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
              </div>
              <div className="transaction-table container" style={{ overflow: "unset", border: "1px solid #c8c3c3" }}>
                <CreateTableViewSchedule
                  dataList={weeklySchedule}
                  setDataList={setWeeklySchedule}
                  dataHeader={header}
                  dataAccessor={accessor}
                  deleteHandleClick={openDeleteForm}

                  handleSubmit={handleSubmit}
                  handleUpdate={handleUpdate}
                  setWeeklySchedule={setWeeklySchedule}

                  schedulesAddState={schedulesAddState}
                  setSchedulesAddState={setSchedulesAddState}
                  schedulesUpdateState={schedulesUpdateState}
                  setSchedulesUpdateState={setSchedulesUpdateState}

                  addHandleClick={addHandleClick}
                  addHandleClick_cancel={addHandleClick_cancel}
                  updateHandleClick={updateHandleClick}
                  updateHandleClick_cancel={updateHandleClick_cancel}

                  dayType={dayType}
                  setDayType={setDayType}
                  locationId={locationId}
                  setLocationId={setLocationId}
                  shiftScheduleId={shiftScheduleId}
                  setShiftScheduleId={setShiftScheduleId}
                />
                {weeklySchedule && weeklySchedule.length > 0 ? (
                  <div></div>
                )
                  :
                  (
                    <div>
                      {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                          <img src={loadingSpinner} alt="Loading..." />
                        </div>
                      ) : (
                        schedulesAddState || schedulesUpdateState ? <></>
                          :
                          <div> {/*<p>No records to display</p>*/}</div>
                      )
                      }
                    </div>
                  )}
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
            </div>
          </div>
        )}
      </div>
      <DeleteForm isOpen={showDeleteForm}
        onClose={closeDeleteForm}
        handleDelete={handleDelete}
      >
      </DeleteForm>
      <GenerateMessage form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      >
      </GenerateMessage>
      {loadingRequest ? (
        <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: "3005" }}>
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      }
    </>
  );
}
export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, editHandleClick, deleteHandleClick, viewSchedule, openFixedLogs }) {
  const itemsPerPage = 10;

  const columns = React.useMemo(() =>
    dataHeader.map((header, index) => ({
      Header: header,
      accessor: dataAccessor[index]
    })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? []  // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
      }
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" }
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${sortHeaderValue.id === column.id
                      ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                      : ""
                    }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 &&
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          }
          {currentItems.map((row) => {
            prepareRow(row)
            return (
              <tr key={row.original.id}
                {...row.getRowProps()}
              >
                {row.cells.map((cell) => (
                  SetInfo(cell.render("Cell").props.column.Header,
                    cell,
                    editHandleClick,
                    deleteHandleClick,
                    viewSchedule,
                    openFixedLogs
                  )
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <>
          <div className='table-page row' style={{ alignItems: "center", justifyContent: "end", padding: "20px 0 0 0" }}>
            <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "26px" }}>
              &lt;&lt;
            </button>
            <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "26px" }}>
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight: "5px", height: "26px" }}>
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height: "26px" }}>
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </>
      ) :
        <></>}
    </>
  )
}
function SetInfo(header, _cell, editHandleClick, deleteHandleClick, viewSchedule, openFixedLogs) {
  const data = _cell.render("Cell").props.row.original;

  if (header === "") {
    return (
      <td>
        <div className="row" style={{ alignItems: "center", justifyContent: "center" }}>
          <Tooltip text="Update">
            <div style={{ padding: "0 5px" }} onClick={() => editHandleClick(data)}><ModeEditIcon /></div>
          </Tooltip>
          {/* ADDED: Fixed Logs Trigger */}
          {FEATURES.TIMEENTRIES_FIXEDLOGS_CONFIG && (
            <Tooltip text="Fixed Logs Config">
              <div style={{ padding: "0 5px", cursor: "pointer", color: "#668fca" }} onClick={() => openFixedLogs(data)}>
                <TuneIcon />
              </div>
            </Tooltip>
          )}
          {deleteHandleClick ?
            <Tooltip text="Delete">
              <div style={{ padding: "0 5px" }} onClick={() => deleteHandleClick(data)}><DeleteForeverIcon /></div>
            </Tooltip>
            :
            <></>
          }
        </div>
      </td>
    )
  }
  if (header === "Weekly Schedule") {
    return (
      <td>
        <div className="row" style={{ alignItems: "center", justifyContent: "center" }}>
          <Tooltip text="View">
            <div style={{ padding: "0 5px" }} onClick={() => viewSchedule(data)}><CalendarMonthIcon /></div>
          </Tooltip>
        </div>
      </td>
    )
  }

  if (header === "Status") {
    if (data.isActive) {
      return (
        <td>
          Active
        </td>
      )
    }
    else {
      return (
        <td>
          InActive
        </td>
      )
    }
  }

  if (header === "Approved?") {
    return (
      <td>
        <input type="checkbox"
          id="overtime-allowance"
          className="checkbox"
          name=""
          checked={data.isApproved}
          disabled={true}
        />
      </td>
    )
  }

  if (header === "Enabled?") {
    return (
      <td>
        <input type="checkbox"
          id="overtime-allowance"
          className="checkbox"
          name=""
          checked={data.idEnabled}
          disabled={true}
        />
      </td>
    )
  }

  if (header === "Time From"
    || header === "Time To"
    || header === "Time In"
    || header === "Time Out"
  ) {
    const time = _cell.render("Cell").props.value;
    if (!time) {
      return (
        <td>
        </td>
      );
    }

    let timeParts;
    let formattedTime;

    if (globalTimeFormat === "Standard Time") {
      const timeSplit = time.split('T');
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(':');
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      formattedTime = `${hours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time") {
      const timeSplit = time.split('T');
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(':');
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      formattedTime = `${hours}:${minutes}`;
    }

    return (
      <td>
        {formattedTime}
      </td>
    );
  }

  if (header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    || header === "Date Requested"
  ) {
    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return (
        <td>
        </td>
      );
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return (
      <td>
        {formattedDateFrom}
      </td>
    )
  }

  //Double type data
  if (header === "Over Percentage"
    || header === "Deduction"
    || header === "Salary"
    || header === "Employee"
    || header === "Employer"
    || header === "Range From"
    || header === "Range To"
    || header === "Monthly Salary"
    || header === "SSS ER"
    || header === "SSS EE"
    || header === "SSS Total"
    || header === "ECER"
    || header === "Total Contribution ER"
    || header === "Total Contribution EE"
    || header === "Total Contribution Total"
    || header === "SE Total Contribution"
    || header === "Salary Range From"
    || header === "Salary Range To"
    || header === "Total Monthly Premium"
    || header === "Percentage"
    || header === "Amount"
    || header === "Total Loan"
    || header === "Total Balance"
    || header === "Default Deduction"
    || header === "Allowance"
    || header === "Daily Salary"
    || header === "Allowance"
    || header === "Total Basic"
    || header === "Rate"
    || header === "Hours OT Regular"
    || header === "Total OT Regular"
    || header === "Hours OT Exceeded"
    || header === "Total OT Exceeded"
    || header === "Hours OT Restday"
    || header === "Total OT Restday"
    || header === "Hours Holiday Special"
    || header === "Total Holiday Special"
    || header === "Hours Holiday Regular"
    || header === "Total Holiday Regular"
    || header === "Hours Restday Holiday Special"
    || header === "Total Restday Holiday Special"
    || header === "Hours Restday Holiday Regular"
    || header === "Total Restday Holiday Regular"
    || header === "Additions"
    || header === "SSS"
    || header === "Pagibig"
    || header === "Philhealth"
    || header === "SSS Loan"
    || header === "SSS Calamity Loan"
    || header === "Pagibig Loan"
    || header === "Pagibig Calamity Loan"
    || header === "Tax"
    || header === "Deductions"
    || header === "Adjustments"
    || header === "Total Net Pay"
    || header === "Days Absent"
    || header === "Absent/s"
    || header === "Days Leave"
    || header === "Leave/s"
    || header === "Hours Exceeded"
    || header === "Total Exceeded"
    || header === "Hours Undertime"
    || header === "Undertime"
    || header === "Hours Late"
    || header === "Late"
    || header === "Night Diff"
    || header === "OT Regular"
    || header === "OT Restday"
    || header === "Holiday Special"
    || header === "Holiday Regular"
    || header === "Restday Holiday Special"
    || header === "Restday Holiday Regular"
    || header === "Total Absents"
    || header === "Total Late"
    || header === "Total Undertime"
    || header === "Total Leaves"
    || header === "Total Night Diff"
    || header === "Total Exceed"
    || header === "Exceed"
  ) {
    const value = _cell.render("Cell").props.value;

    // Check if value is a number
    const isNumber = typeof value === 'number';

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    if (!isNumber) {
      return (
        <td {..._cell.getCellProps()}> {
          _cell.render("Cell")
        }
        </td>
      )
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    return (
      <td>
        {formattedNumber}
      </td>
    )
  }

  return (
    <td {..._cell.getCellProps()}> {
      _cell.render("Cell")
    }
    </td>
  )
}
export function CreateTableForUpload({ dataList = [],
  dataHeader = [],
  dataAccessor = [],
  currentPage, setCurrentPage,
}) {
  const itemsPerPage = 7;

  const columns = React.useMemo(() =>
    dataHeader.map((header, index) => ({
      Header: header,
      accessor: dataAccessor[index]
    })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? []  // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
      }
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" }
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <div>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${sortHeaderValue.id === column.id
                      ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                      : ""
                    }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 &&
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          }
          {currentItems.map((row) => {
            prepareRow(row)
            return (
              <tr key={row.original.id}
                {...row.getRowProps()}
                className={row.original.error ? "error" : ""}
              >
                {row.cells.map((cell) => (
                  <SetInfoForUpload header={cell.render("Cell").props.column.Header}
                    _cell={cell}
                  />
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <div>
          <div className='table-page row' style={{ alignItems: "center", justifyContent: "end", padding: "20px 0 0 0" }}>
            <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "25px" }}>
              &lt;&lt;
            </button>
            <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "25px" }}>
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight: "5px", height: "25px" }}>
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height: "25px" }}>
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </div>
      ) :
        <></>}
    </div>
  )
}
function SetInfoForUpload({ header,
  _cell,
}) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "Photo") {
    if (data.photo) {
      const imageSrc = 'data:image/jpeg;base64,' + data.photo;

      return (
        <td>
          <img className="avatarImg" src={imageSrc} alt="" />
        </td>
      )
    }
    return (
      <td>
        <img className="avatarImg" src="images/sample.jpg" alt="" />
      </td>
    )
  }

  if (header === "Date Created"
  ) {
    if (!value) {
      return (
        <td>
        </td>
      );
    }

    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return (
        <td>
          null
        </td>
      );
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return (
      <td>
        {formattedDateFrom}
      </td>
    )
  }

  if (header === "Error"
  ) {
    return (
      <td>
        {value && (
          <p style={{ color: "red", margin: 0 }}>
            {value}
          </p>
        )}
      </td>
    );
  }

  if (header === "Vacation Leave"
    || header === "Sick Leave"
    || header === "Service Incentive Leave"
    || header === "Solo Parent Leave"
    || header === "Vacation Leave Remaining"
    || header === "Sick Leave Remaining"
    || header === "Service Incentive Leave Remaining"
    || header === "Solo Parent Leave Remaining"
  ) {
    const value = _cell.render("Cell").props.value;

    // Check if value is a number
    const isNumber = typeof value === 'number';

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    if (!isNumber) {
      return (
        <td {..._cell.getCellProps()}> {
          _cell.render("Cell")
        }
        </td>
      )
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    return (
      <td>
        {formattedNumber}
      </td>
    )
  }

  return (
    <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
  )
}
export function CreateTableViewSchedule({ dataList = [], setDataList, dataHeader = [], dataAccessor = [],
  deleteHandleClick,
  setWeeklySchedule,

  handleSubmit,
  handleUpdate,

  schedulesAddState,
  setSchedulesAddState,
  schedulesUpdateState,
  setSchedulesUpdateState,

  addHandleClick,
  addHandleClick_cancel,
  updateHandleClick,
  updateHandleClick_cancel,

  dayType,
  setDayType,
  locationId,
  setLocationId,
  shiftScheduleId,
  setShiftScheduleId,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [recoveredData, setRecoveredData] = useState([]);

  const columns = React.useMemo(() =>
    dataHeader.map((header, index) => ({
      Header: header,
      accessor: dataAccessor[index]
    })),
    [dataHeader, dataAccessor]
  );

  const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setSortBy
  } = useTable(
    {
      columns,
      data: dataList,
      initialState: {
        sortBy: sortHeaderValue.isDefault
          ? []  // No sorting if it's default
          : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
      }
    },
    useSortBy
  );

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const saveAdd = async (e) => {
    await handleSubmit(e);

    addHandleClick_cancel();
    updateHandleClick_cancel();
  }

  const updateClickIn = (data) => {
    addHandleClick_cancel();
    setRecoveredData(data);
    updateHandleClick(data);

    const foundData = dataList.find(_data => _data.id === data.id);

    setDataList(prevDataList =>
      prevDataList.filter(_data => _data.id !== foundData.id)
    );
  }

  const saveUpdate = async (e) => {
    await handleUpdate(e);

    addHandleClick_cancel();
    updateHandleClick_cancel();
  }

  const updateClickIn_cancel = () => {
    const oldData = {
      id: recoveredData.id,
      employeePersonalInformationId: recoveredData.employeePersonalInformationId,
      employeePersonalInformationEmployeeId: recoveredData.employeePersonalInformationEmployeeId,
      employeePersonalInformationFullName: recoveredData.employeePersonalInformationFullName,
      shiftScheduleId: recoveredData.shiftScheduleId,
      shiftScheduleShiftName: recoveredData.shiftScheduleShiftName,
      locationId: recoveredData.locationId,
      locationDescription: recoveredData.locationDescription,
      day: recoveredData.day,
    }

    setDataList(prevDataList => [
      ...prevDataList,
      oldData
    ]);

    setDayType("");
    setLocationId("");
    setShiftScheduleId("");

    updateHandleClick_cancel();
  }

  //Sorting Feature
  const sortState = [
    { id: 0, state: "default", textValue: "" },
    { id: 1, state: "ascending", textValue: "↑" },
    { id: 2, state: "descending", textValue: "↓" }
  ];

  const headerClick = (column) => {
    if (sortHeaderValue.id !== column.id) {
      // New column selected, start with ascending order
      setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
      setSortBy([{ id: column.id, desc: false }]);
    } else {
      // Toggle between sorting states (default -> ascending -> descending -> default)
      if (sortHeaderValue.isDefault) {
        setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
        setSortBy([{ id: column.id, desc: false }]);
      } else if (!sortHeaderValue.desc) {
        setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
        setSortBy([{ id: column.id, desc: true }]);
      } else {
        setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
        setSortBy([]); // Clear sorting
      }
    }
  };

  // Ensure sorting is reapplied on dataList reload
  useEffect(() => {
    if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
      setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
    }
  }, [dataList, setSortBy, sortHeaderValue]);

  return (
    <>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  onClick={() => headerClick(column)}
                  className="sortable-header"
                >
                  {`${column.render("Header")} ${sortHeaderValue.id === column.id
                      ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                      : ""
                    }`}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {schedulesAddState &&
            <tr>
              <td>
                <DaySelect dayType={dayType} setDayType={setDayType} />
              </td>
              <td>
                <LocationIdSelect locationId={locationId} setLocationId={setLocationId} />
              </td>
              <td>
                <ShiftScheduleIdSelect shiftScheduleId={shiftScheduleId} setShiftScheduleId={setShiftScheduleId} />
              </td>
              <td>
                <div className="row itinerary-manage" style={{ alignItems: "center", justifyContent: "center" }}>
                  <Tooltip text="Save">
                    <div style={{ padding: "0 5px" }} onClick={saveAdd}><SaveIcon /></div>
                  </Tooltip>
                  <Tooltip text="Cancel">
                    <div style={{ padding: "0 5px" }} onClick={addHandleClick_cancel}><DoDisturbIcon /></div>
                  </Tooltip>
                </div>
              </td>
            </tr>
          }
          {schedulesUpdateState &&
            <tr>
              <td>
                <DaySelect dayType={dayType} setDayType={setDayType} />
              </td>
              <td>
                <LocationIdSelect locationId={locationId} setLocationId={setLocationId} />
              </td>
              <td>
                <ShiftScheduleIdSelect shiftScheduleId={shiftScheduleId} setShiftScheduleId={setShiftScheduleId} />
              </td>
              <td>
                <div className="row itinerary-manage" style={{ alignItems: "center", justifyContent: "center" }}>
                  <Tooltip text="Save">
                    <div style={{ padding: "0 5px" }} onClick={saveUpdate}><SaveIcon /></div>
                  </Tooltip>
                  <Tooltip text="Cancel">
                    <div style={{ padding: "0 5px" }} onClick={updateClickIn_cancel}><DoDisturbIcon /></div>
                  </Tooltip>
                </div>
              </td>
            </tr>
          }
          {currentItems.map((row) => {
            prepareRow(row)
            return (
              <tr key={row.original.id}
                {...row.getRowProps()}
              >
                {row.cells.map((cell) => (
                  SetInfoViewSchedule(cell.render("Cell").props.column.Header,
                    cell,
                    updateClickIn,
                    deleteHandleClick
                  )
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <>
          <div className='table-page row' style={{ alignItems: "center", justifyContent: "end", padding: "20px 0 0 0" }}>
            <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "26px" }}>
              &lt;&lt;
            </button>
            <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
              style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight: "5px", height: "26px" }}>
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight: "5px", height: "26px" }}>
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
              style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height: "26px" }}>
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </>
      ) :
        <></>}
    </>
  )
}
function SetInfoViewSchedule(header, _cell, editHandleClick, deleteHandleClick) {
  const data = _cell.render("Cell").props.row.original;

  if (header === "") {
    return (
      <td>
        <div className="row" style={{ alignItems: "center", justifyContent: "center" }}>
          <Tooltip text="Update">
            <div style={{ padding: "0 5px" }} onClick={() => editHandleClick(data)}><ModeEditIcon /></div>
          </Tooltip>
          {deleteHandleClick ?
            <Tooltip text="Delete">
              <div style={{ padding: "0 5px" }} onClick={() => deleteHandleClick(data)}><DeleteForeverIcon /></div>
            </Tooltip>
            :
            <></>
          }
        </div>
      </td>
    )
  }

  return (
    <td {..._cell.getCellProps()}> {
      _cell.render("Cell")
    }
    </td>
  )
}
const Tooltip = ({ text, children }) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block', zIndex: "1" }}>
      <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {children}
      </div>
      {show && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '-50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'white',
            color: 'gray',
            padding: '5px',
            borderRadius: '5px',
            pointerEvents: "none",
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};

function DaySelect({ dayType, setDayType }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setDayType(event.target.value);
  };

  useEffect(() => {
    if (dayType !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [dayType]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={dayType} onChange={handleSelectChange} style={{ height: "30px", color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose day</option>
        <option value="Monday">Monday</option>
        <option value="Tuesday">Tuesday</option>
        <option value="Wednesday">Wednesday</option>
        <option value="Thursday">Thursday</option>
        <option value="Friday">Friday</option>
        <option value="Saturday">Saturday</option>
        <option value="Sunday">Sunday</option>
      </select>
    </div>
  );
};
function ShiftScheduleIdSelect({ shiftScheduleId, setShiftScheduleId }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setShiftScheduleId(event.target.value);
  };

  const [shiftScheduleIds, setShiftScheduleIds] = useState([]);

  const apiUrl = domain + "/api/ShiftSchedule";

  const fetchData = useCallback(async () => {
    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        setShiftScheduleIds(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, [apiUrl]);

  useEffect(() => {
    fetchData();

    if (shiftScheduleId !== "") {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }

  }, [fetchData, shiftScheduleId]);

  return (
    <div>
      <select id="overtime-employee-name" value={shiftScheduleId} onChange={handleSelectChange} style={{ height: "30px", color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose shift schedule</option>
        {shiftScheduleIds.map((shiftScheduleId) => (
          SetShiftScheduleId(shiftScheduleId)
        ))}
      </select>
    </div>
  );
};
function SetShiftScheduleId(shiftScheduleId) {
  const formatTime = (time) => {
    let timeParts;
    let formattedTime;

    if (globalTimeFormat === "Standard Time") {
      const timeSplit = time.split('T');
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(':');
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      formattedTime = `${hours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time") {
      const timeSplit = time.split('T');
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(':');
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      formattedTime = `${hours}:${minutes}`;
    }

    return formattedTime;
  }

  return (
    <option id={"overtimeAdd" + shiftScheduleId.id} value={shiftScheduleId.id}>{`${shiftScheduleId.id} -  ${shiftScheduleId.shiftName} (${formatTime(shiftScheduleId.timeFrom)} - ${formatTime(shiftScheduleId.timeTo)}) `}</option>
  )

}
function LocationIdSelect({ locationId, setLocationId }) {
  const [isSelected, setIsSelected] = useState(false);

  const handleSelectChange = (event) => {
    setIsSelected(true);
    setLocationId(event.target.value);
  };

  const [data, setData] = useState([]);

  const fetchData = async () => {
    const apiUrl = domain + "/api/Location/active";

    await axios.get(apiUrl, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' // You can include other headers if needed
      }
    })
      .then(response => {
        response.data.sort((a, b) => a.description.localeCompare(b.description));
        setData(response.data); // Set the response data to the state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }

  useEffect(() => {
    fetchData();
    if (locationId !== "" && locationId !== 0) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [locationId]);

  return (
    <div>
      <select id="employee-select-PagibigReport" value={locationId} onChange={handleSelectChange} style={{ height: "30px", color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
        <option value="" disabled hidden>Choose location</option>
        {data.map((locationId) => (
          SetLocationId(locationId)
        ))}
      </select>
    </div>
  );
};
function SetLocationId(locationId) {
  return (
    <option value={locationId.id}>{
      locationId.description}
    </option>
  )

}
function DeleteForm({ isOpen,
  onClose,
  handleDelete }
) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Delete!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span>Are you sure you want to delete this data?</span>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={handleDelete}
                style={{ marginRight: "5px" }}>
                DELETE
              </button>
              <button id="add-family"
                className="cancel row"
                onClick={() => handleClose()}>
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export default EmployeeSchedule
